'use client'

import { useMemo } from 'react'
import { useField, useFormFields } from '@payloadcms/ui'

const labelStyle: React.CSSProperties = {
  display: 'block', marginBottom: 6, fontSize: 11, fontWeight: 600,
  textTransform: 'uppercase', letterSpacing: '0.08em', color: '#9a9a9a',
}
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '6px 10px', border: '1px solid #d0d0d0', borderRadius: 4,
  fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit',
}

export function StartSceneSelect({ path }: { path: string }) {
  const { value, setValue } = useField<string>({ path })
  const scenesBasePath = path.replace(/\.startScene$/, '.scenes')

  const { rows } = useField<unknown>({ path: scenesBasePath, hasRows: true })
  const allFields = useFormFields(([fields]) => fields)

  const options = useMemo(() => {
    return (rows || []).map((r, i) => {
      const title = allFields?.[`${scenesBasePath}.${i}.title`]?.value as string | undefined
      return { id: (r as { id: string }).id, title: title || `Scene ${i + 1}` }
    })
  }, [rows, allFields, scenesBasePath])

  return (
    <div style={{ marginBottom: 8 }}>
      <label style={labelStyle}>Starting Scene</label>
      <select value={value || ''} onChange={e => setValue(e.target.value)} style={inputStyle}>
        <option value="">— choose starting scene —</option>
        {options.map(o => (
          <option key={o.id} value={o.id}>{o.title}</option>
        ))}
      </select>
      {options.length === 0 && (
        <div style={{ fontSize: 11, color: '#9a9a9a', marginTop: 4 }}>Add at least one scene first.</div>
      )}
    </div>
  )
}
